import React from 'react';
import Dialog from 'material-ui/Dialog'
import AcquireWebComponent from '../../../framework/MaterialUI/index'
import FlatButton from 'material-ui/FlatButton';
import {FullRow, Row, Col} from '../../../framework/Grid'
import ChannelCampaignsTable from '../../ChannelCampaignsTable';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import moment from "moment/moment";
import union from 'lodash/union';
import Search from 'material-ui/svg-icons/action/search'
import "./add-campaign.css";

class AddCampaignDialog extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.state={
			openDialog : props.open,
			channelCampaigns: union(/*props.channelCampaigns,*/ props.emailCampaigns),
			originChannelCampaigns: props.channelCampaigns,
			sltCampaigns:[],
			searchText: ''
		}
	}

	componentWillReceiveProps(nextProps){
		this.setState({
			openDialog: nextProps.open
		})

		//if ((!isEqual(nextProps.channelCampaigns.slice().sort(), this.props.channelCampaigns.slice().sort())) || 
		//	(!isEqual(nextProps.emailCampaigns.slice().sort(), this.props.emailCampaigns.slice().sort()))) {
		if (this.props.selectCampaignIds) {
			const vals = []
			const sltIds = []
			nextProps.channelCampaigns.forEach((item)=>{
				const val = Object.assign({select:false}, item);
				if (this.props.selectCampaignIds.indexOf(item.id) >= 0) {
					val.select = true;
					sltIds.push(item.id);
				}
				vals.push(val);
			})
			
			nextProps.emailCampaigns.forEach((item) => {
				const val = Object.assign({select:false}, item);
				if (this.props.selectCampaignIds.indexOf(item.id) >= 0) {
					val.select = true;
					sltIds.push(item.id);
				}
				vals.push(val);
			})
			this.setState({
				channelCampaigns: vals,
				originChannelCampaigns: vals,
				sltCampaigns: sltIds
			})
		}
	}

	selectCampaignIds(id){
		const idx = this.state.sltCampaigns.indexOf(id);
		if (idx < 0) {
			this.state.sltCampaigns.push(id);
		} else {
			this.state.sltCampaigns.splice(idx, 1)
		}
		this.forceUpdate();
	}

	clickBtnAddCampaign(e){
		e.preventDefault();
		this.props.applyChange(this.state.sltCampaigns, this.props.deployName);
		this.props.onRequestClose();
		this.setState({
			openDialog: false,
			sltCampaigns: []
		})
	}
	onSearchChange(e){
		const result = filter(this.state.originChannelCampaigns, (obj)=>{
			return isEmpty(e.target.value.trim()) ? true : 
				(obj.name.indexOf(e.target.value.trim()) >= 0) || (obj.campaignId.indexOf(e.target.value.trim()) >= 0)
		});

		this.setState({
			channelCampaigns: result,
			searchText: e.target.value.trim()
		});
		this.forceUpdate();
	}

	handleSearch(e) {
		e.preventDefault();
		
	}


	render() {
		const actions = [
			<FlatButton
			label="Cancel"
			primary={true}
			className="black-border mr-20 btn-aa-claritas-info"
			backgroundColor={'#FFFFFF'}
			labelStyle={{ color: '#000', textTransform:"capitalize", fontSize:"16px"}}
			hoverColor={'#FFFFFF'}
			onClick={(e)=>{e.preventDefault();this.setState({openDialog: false, sltCampaigns:[]});this.props.onRequestClose();}}
		/>,
		<FlatButton
			label="Add Segment"
			primary={true}
			className="btn-aa-claritas btn-claritas-default btn-aa-claritas-default"
			labelStyle={{ color: '#FFFFFF', textTransform:"capitalize", fontSize:"16px"}}
			hoverColor={'#FFFFFF'}
			onClick={this.clickBtnAddCampaign.bind(this)}
		/>		
		]
		return (
			<Dialog modal={true} title="" open={this.state.openDialog} onRequestClose={this.props.onRequestClose}
				bodyStyle={{ color: "#000", fontSize:'16px', padding:'20px' }} contentStyle={{width:'1024px', maxWidth:'1024px'}}
				titleStyle={{display:'none'}} actionsContainerStyle={{padding:"20px"}}
				actions={actions}
			>
				<FullRow className="light-grey-border no-margin-left no-margin-right no-padding mb-20">
					<h3 className="pl-10" style={{fontSize:'24px', fontWeight:'bold'}}>CAMPAIGN GROUP</h3>
					<Row className="no-padding no-margin pl-10">
						<Col xs="3" sm="3" md="3" lg="3" className="no-padding no-margin">
							<strong style={{fontSize:'16px'}}>Campaign Group Name</strong>
						</Col>
						<Col xs="4" sm="4" md="4" lg="4" className="no-padding no-margin">{this.props.campaignName}</Col>
						<Col xs="3" sm="3" md="3" lg="3" className="no-padding no-margin"><strong>Campaign Group Start Date</strong></Col>
						<Col xs="2" sm="2" md="2" lg="2" className="no-padding no-margin">{moment(this.props.startDate).format("MM/DD/YY")}</Col>
					</Row>
					<Row className="pl-10 no-margin-bottom pt-10 ">
						<Col xs="3" sm="3" md="3" lg="3"><strong>Campaign Group Status</strong></Col>
						<Col xs="4" sm="4" md="4" lg="4">{this.props.campaignStatus}</Col>
						<Col xs="3" sm="3" md="3" lg="3"><strong>Campaign Group End Date</strong></Col>
						<Col xs="2" sm="2" md="2" lg="2">{moment(this.props.endDate).format("MM/DD/YY")}</Col>
					</Row>
				</FullRow>
				<FullRow className="light-grey-border no-padding no-margin-left no-margin-right no-margin-bottom deployment-section">
					<h3 className="pl-10" style={{fontSize:'16px', fontWeight:'bold'}}>{this.props.title}</h3>
					{
						  
						<FullRow className="pl-10 pr-10 pt-10 no-margin-bottom">
							<div className="search-wrapper clearfix mb-20">
								<span className="search-tit" style={{fontSize:'16px'}}>Search</span>
								<div className="search-bar" style={{width:"320px", border:"solid 1px #EEEFF2"}}>
									<input placeholder="Search by Name or ID"
										style={{width:'100%', lineHeight:'25px', border:'none'}}
										onChange={this.onSearchChange.bind(this)} />
								</div>
								<div className="icon">
									<button onClick={this.handleSearch.bind(this)}>
										<Search
											style={{color: 'white', marginLeft: '-4px', marginTop: '2px'}}
										/>
									</button>
								</div>
							</div>{
							isEmpty(this.state.channelCampaigns) ? (
							<span style={{color:"#FF0000"}}>No {this.props.channelType.toLowerCase()} segments within date range selected</span>
						):
							<ChannelCampaignsTable tableHeaderArr={
										[
											{label: '', value: 0},
											{label: 'Segment Name', value: 1},
											{label: 'Segment ID', value: 2},
											{label: 'Segment Start Date', value: 3},
											{label: 'Segment End Date', value: 4},
											{label: 'Status', value: 5}
										]
									} activeIndex={1} bodyDataArr={this.state.channelCampaigns} 
									bodyDataKey={['select','name', 'campaignId','startDate','endDate','status']}
									selectCampaignIds={this.selectCampaignIds.bind(this)}
									sltCampaignIds={this.state.sltCampaigns}
									tableHeaderWidthStyle={
										['7%', '28%', '19%', '18%', '18%', '10%']
									}
							/>	}				
						</FullRow>
					}
					{/*
					<FullRow className="pr-10 no-padding-top no-margin-bottom no-padding-top text-right" style={{fontSize:"16px"}}>
						<FlatButton
							label="Cancel"
							primary={true}
							className="black-border mr-20 btn-aa-claritas-info"
							backgroundColor={'#FFFFFF'}
							labelStyle={{ color: '#000', textTransform:"capitalize", fontSize:"16px"}}
							hoverColor={'#FFFFFF'}
							onClick={(e)=>{e.preventDefault();this.setState({openDialog: false, sltCampaigns:[]});this.props.onRequestClose();}}
						/>
						<a onClick={this.clickBtnAddCampaign.bind(this)}
							style={{textTransform:"capitalize"}}
							className="btn btn-default btn-aa-default btn-aa-claritas black-border legitRipple">Add Segment</a>
					</FullRow>*/}
				</FullRow>
			</Dialog>
		)
	}
}

export default AddCampaignDialog

AddCampaignDialog.defaultProps = {
	channelCampaigns: [],
	campaignStatus:"Draft"
}


// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/AddCampaign/AddCampaignDialog.jsx